import { StrictMode, useState } from "react";
import { Router } from "./Router";
import { MobixStoreContext } from "@/hooks/useStore";
import { RootStore } from "@/stores/RootStore";
import "./translations";
import { useMixPanelInit } from "./useMixPanelInit";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";

const Application = () => {
	useMixPanelInit();
	const [rootStore] = useState(() => new RootStore());
	return (
		<MobixStoreContext.Provider value={rootStore}>
			<TooltipProvider delayDuration={250} skipDelayDuration={150}>
				<Toaster richColors position="bottom-right" />
				<Router />
			</TooltipProvider>
		</MobixStoreContext.Provider>
	);
};

export const App = () => {
	return (
		<StrictMode>
			<Application />
		</StrictMode>
	);
};
